export const ArrowLeftInCircle = () => {
    return (
        <svg
            width="28"
            height="28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M13.6.5a13.09 13.09 0 1 1 0 26.2 13.09 13.09 0 1 1 0-26.2Zm0 25.6c6.92 0 12.5-5.58 12.5-12.5S20.52 1.1 13.6 1.1 1.1 6.68 1.1 13.6s5.58 12.5 12.5 12.5Zm11.5-12.5a11.49 11.49 0 1 1-23 0 11.49 11.49 0 1 1 23 0Z"
                fill="#F8F6DF"
                stroke="#000"
            />
            <path
                d="m13.84 5.84 1.12 1.12-6.64 6.64 6.64 6.64-1.12 1.12-7.76-7.76 7.76-7.76Z"
                fill="#140101"
            />
            <path d="M20.8 14.4H7.2v-1.6h13.6v1.6Z" fill="#140101" />
        </svg>
    );
};
